import { defineAsyncComponent } from 'vue';
import VueSplide from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/themes/splide-skyblue.min.css';
import VueToast from 'vue-toast-notification';
import { mountApp, app } from '@/js/app-entries/app-entry-points/global';
import 'vue-toast-notification/dist/theme-sugar.css';

const ImageCarousel = defineAsyncComponent(() => import('@/js/dapps/ImageCarousel.vue'));
const DappStatsCard = defineAsyncComponent(() => import('@/js/dapps/DappStatsCard.vue'));
const DappStats = defineAsyncComponent(() => import('@/js/dapps/DappStats.vue'));
const ShareTippy = defineAsyncComponent(() => import('@/js/components/Tippy/ShareTippy/ShareTippy.vue'));
const NftChartMain = defineAsyncComponent(() => import('@/js/dapps/NftChartMain.vue'));
const LearnListButton = defineAsyncComponent(() => import('@/js/global/buttons/LearnListButton.vue'));
const LatestNewsAndVideos = defineAsyncComponent(() => import('@/js/global/widgets/LatestNewsAndVideos.vue'));

app.use(VueSplide);
app.use(VueToast);

app.component('DappStatsCard', DappStatsCard);
app.component('ImageCarousel', ImageCarousel);
app.component('DappStats', DappStats);
app.component('ShareTippy', ShareTippy);
app.component('NftChartMain', NftChartMain);
app.component('LearnListButton', LearnListButton);
app.component('LatestNewsAndVideos', LatestNewsAndVideos);

mountApp();
